// Component to change the range dates (weekly) of current dispatch schedule
import WeekPicker, { WeekObject } from '@/components/WeekPicker/WeekPicker';

import { useSchedulerContext } from '@/context/SchedulerContext';

export default function SchedulerRange() {
  const {
    schedulerStartDate,
    schedulerEndDate,
    schedulerCurrentDate,
    setSchedulerRangeDates,
  } = useSchedulerContext();

  const onChangeWeek = (week: WeekObject) => {
    setSchedulerRangeDates(week.firstDay, week.lastDay, week.selectedDay);
  };

  return (
    <div className="scheduler-range flex flex-1 justify-end md:py-5">
      <WeekPicker
        startDate={schedulerStartDate}
        endDate={schedulerEndDate}
        selectedDate={schedulerCurrentDate}
        onChange={onChangeWeek}
      />
    </div>
  );
}
